import React from 'react';

const Resources = ({ onNavigate, onShowAuth }) => {
  const blogPosts = [
    {
      category: 'BLOG',
      date: 'Dec 10, 2021',
      title: 'Understanding Your Payment Analytics Dashboard',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      link: '#'
    },
    {
      category: 'RESOURCES',
      date: 'Dec 10, 2021',
      title: 'Maximizing Business Growth with Data-Driven Insights',
      image: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      link: '#'
    },
    {
      category: 'GUIDES',
      date: 'Dec 10, 2021',
      title: 'The Future of Payment Processing Technology',
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      link: '#'
    },
    {
      category: 'BLOG',
      date: 'Dec 8, 2021',
      title: 'How to Reduce Credit Card Processing Fees',
      image: 'https://images.unsplash.com/photo-1556740758-90de374c12ad?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      link: '#'
    },
    {
      category: 'GUIDES',
      date: 'Dec 5, 2021',
      title: 'Understanding Interchange Rates and Markups',
      image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      link: '#'
    },
    {
      category: 'RESOURCES',
      date: 'Dec 3, 2021',
      title: 'Small Business Guide to Payment Processing',
      image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      link: '#'
    },
    {
      category: 'BLOG',
      date: 'Nov 30, 2021',
      title: 'Payment Gateway Security Best Practices',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      link: '#'
    },
    {
      category: 'RESOURCES',
      date: 'Nov 28, 2021',
      title: 'E-commerce Payment Solutions Comparison',
      image: 'https://images.unsplash.com/photo-1556742111-a301076d9d18?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      link: '#'
    },
    {
      category: 'GUIDES',
      date: 'Nov 25, 2021',
      title: 'Chargeback Prevention Strategies',
      image: 'https://images.unsplash.com/photo-1554224154-26032fced8bd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      link: '#'
    },
    {
      category: 'BLOG',
      date: 'Nov 22, 2021',
      title: 'Mobile Payment Trends in 2021',
      image: 'https://images.unsplash.com/photo-1556740772-1a741367b93e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      link: '#'
    },
    {
      category: 'RESOURCES',
      date: 'Nov 20, 2021',
      title: 'PCI Compliance Guide for Small Businesses',
      image: 'https://images.unsplash.com/photo-1556741533-6e6a62bd8b49?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      link: '#'
    },
    {
      category: 'GUIDES',
      date: 'Nov 18, 2021',
      title: 'Setting Up Payment Processing for Startups',
      image: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      link: '#'
    }
  ];

  const getCategoryColor = (category) => {
    switch (category) {
      case 'BLOG':
        return 'text-blue-400';
      case 'RESOURCES':
        return 'text-green-400';
      case 'GUIDES':
        return 'text-purple-400';
      default:
        return 'text-gray-400';
    }
  };

  return (
    <div className="min-h-screen bg-[#00162C] text-white">
      {/* Hero Section */}
      <section className="py-20 px-6 sm:px-8 lg:px-10">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-8">
            Blogs, Resources & Guides
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Lorem ipsum dolor sit amet consectetur adipiscing elit blandit id
            dolor venenatis auctor maecenas egestas arcu ut consectetur.
          </p>
        </div>
      </section>

      {/* Resources Grid */}
      <section className="py-16 px-6 sm:px-8 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post, index) => (
              <div
                key={index}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden hover:bg-white/10 transition-all duration-300 group cursor-pointer"
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                </div>

                {/* Content */}
                <div className="p-6">
                  {/* Category and Date */}
                  <div className="flex items-center justify-between mb-4">
                    <span className={`text-sm font-semibold ${getCategoryColor(post.category)}`}>
                      {post.category}
                    </span>
                    <span className="text-gray-400 text-sm">
                      {post.date}
                    </span>
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-semibold text-white mb-4 line-clamp-2 group-hover:text-blue-400 transition-colors">
                    {post.title}
                  </h3>

                  {/* Read More Link */}
                  <button className="text-blue-400 hover:text-blue-300 font-medium text-sm transition-colors">
                    Read More →
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Resources;